<template>
  <div>
    <h1>Perso</h1>
  </div>
</template>

<script>
export default {
  name: 'PersoView',
}
</script>
